import qs from "qs";
import { getRequestArgs } from "../getRequestArgs.mjs";
const getSDMXUrl = (args) => {
  const { url, params } = getRequestArgs(args);
  return `${url}${qs.stringify(params, { addQueryPrefix: true })}`;
};
export {
  getSDMXUrl
};
